// className 조합 — falsy 제거 후 공백 결합. cx('field', error && 'error', className)
export const cx = (...c: unknown[]) => c.filter(Boolean).join(' ');
